//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mechatronics.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../no/Expression.js";
let d=[[[1,"ExpressionValue",0,"Expression",0],[0,"IOStatus",1,0],[0,"ObjectValue",1,"NXObject",0],[0,"Operator",1,0],[0,"ParameterName",1,0],[0,"ParameterValue",1,0],[0,"PropertyId",1,0]],[[["exp"],"PutExpressionValue",{},1,0],[["expTag"],"SetExpressionWithInit",{},1,0]],[]];
SPLM.Mechatronics.GanttOperationParameterBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mechatronics.GanttOperationParameterBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Mechatronics.GanttOperationParameterBuilder.OperatorOption = Object.freeze({
    "None" : "None", "Increment" : "Increment", "Decrement" : "Decrement", "Multiply" : "Multiply", "Not" : "Not"});

export default SPLM;